<!-- Recherche des réseaux -->

<div class="ligne_form" [formGroup]="searchForm">
    <div class="form-group">
        <mat-form-field>
            <mat-label>{{'network.offerCreator.select.action.value' | translate}}</mat-label>
            <mat-select placeholder="{{'network.offerCreator.select.action.value' | translate}}" [formControlName]="'selection'" [compareWith]="compareItems" (closed)="handleClosure()" multiple="true">
                <mat-option>
                    <ngx-mat-select-search
                        #nameFilter [formControl]="optionFilterNameCtrl"
                        [placeholderLabel]="'network.offerCreator.search.action.value' | translate"
                        [noEntriesFoundLabel]="'network.offerCreator.search.noResult.value' | translate"
                    ></ngx-mat-select-search>
                </mat-option>
                <mat-option disabled="true">{{'network.offerCreator.select.description.value' | translate}}</mat-option>
                <ng-container *ngIf="(filteredOptions | async) as options">
                    <mat-option #matOption *ngFor="let option of options" [value]="option" (click)="handleItemSelection(matOption)">
                        {{ option.name }}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>
</div>

<!-- Sélection actuelle -->

<div class="ligne_form">
    <div class="row marges" *ngIf="selectedItems && selectedItems.length">
        <div class="col y_items_center">
            <div class="selected_offers">
                <span>{{ 'network.offerCreator.selection.list.value' | translate }} :</span>
                <ul>
                    <li *ngFor="let item of selectedItems">{{ item.name }}<mat-icon (click)="removeItemSelection(item)">close</mat-icon></li>
                </ul>
            </div>
        </div>
    </div>
</div>
